// extracted by mini-css-extract-plugin
module.exports = {"root":"Users_root__Mm601","caption":"Users_caption__2vwE-","details":"Users_details__33AIe","detailsArea":"Users_detailsArea__1wKJg","button":"Users_button__3S_0G"};